// ─── Module « calendar » (@mop/feature-calendar) ─────────────────
// My Calendar = MoPCal porté dans la suite. Les données restent PARTAGÉES :
// on lit/écrit les mêmes documents MoPCal via le CALENDRIER hérité de l'espace
// (useEspace().tenantRangement / tenantIds) — aucune copie, aucune migration.
export { default as EcranCalendrier } from './EcranCalendrier';
export { default as EcranFamille } from './EcranFamille';

// Catalogue des fonctions du module (pour <FonctionsProvider catalogue={…}>).
export { FONCTIONS_CALENDRIER } from './fonctions';

// Contenu d'aide du module (pour <AideProvider contenus={…}>).
export { AIDES_CALENDRIER } from './aides';

// Calendriers de l'espace : contexte du calendrier actif + section Profil.
export { CalendrierActifProvider, useCalendrierActif } from './CalendrierActifContext';
export { default as SectionCalendriers } from './SectionCalendriers';
export { default as SectionAccesCalendriers } from './SectionAccesCalendriers';
export { PRATIQUES_CALENDRIER } from './pratiques';
export { default as EcranExport } from './EcranExport';
export { creerCalendrierSuite } from './services/calendriersEspace';
